import * as yup from 'yup'

type ValidationMessages = {
  email: {
    email: string
    required: string
  }
}

export const createForgotPasswordSchema = ({ email }: ValidationMessages) => {
  return yup.object().shape({
    email: yup.string().email(email.email).required(email.required),
  })
}
